import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import '../components/tooltip/tooltip.scss' 
import './about.scss'

const AboutPage = () => (
  <Layout>
    <SEO title="About" />
    <div className="paragraph paragraph--big">
      <p>Since I've graduated from High School in 2017, I moved to the city of Thessaloniki in Greece
          where I'm studying for my degree in Computer Engineering at the Alexander Technological
          Educational Institute of Thessaloniki.</p>
      <p>I'd say Web Development is my forte, and it's what excites me the most when it comes to IT. I
          love a good design and always aim for the best results possible.</p>
      <p>Since I was little I loved to create visuals, be that video, images, a website, whatever...
          doesn't matter as long as I can edit it on my PC. That being said I'm pretty comfortable with
          video/image editing tools and various web technologies.</p>
      <p>Other than that I've been busy with a couple Unity projects in the past.</p>
      <p>Oh, and I love music! I used to play the saxophone for a few years and
          then I played the drums for another two... 
          <span className="about__joke" data-tooltip="This was a joke mom :)" data-tooltip-location="top" >but my brother was better at it so I gave up</span>.
      </p>
  </div>
  </Layout>
)

export default AboutPage
